"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cccisdReduxFormHelpers = require("cccisd-redux-form-helpers");
var _style = _interopRequireDefault(require("./style.css"));
var _OpenClosedButtonGroup = _interopRequireDefault(require("../../../../components/OpenClosedButtonGroup"));
var _InfoLabel = _interopRequireDefault(require("../../../../components/InfoLabel"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var TimeConfig = exports["default"] = /*#__PURE__*/function (_React$Component) {
  function TimeConfig() {
    _classCallCheck(this, TimeConfig);
    return _callSuper(this, TimeConfig, arguments);
  }
  _inherits(TimeConfig, _React$Component);
  return _createClass(TimeConfig, [{
    key: "render",
    value: function render() {
      var _this$props$fields = this.props.fields,
        open = _this$props$fields.open,
        opensOn = _this$props$fields.opensOn,
        closesOn = _this$props$fields.closesOn;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].timeConfig
      }, /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.FieldBlock, {
        field: open,
        label: /*#__PURE__*/_react["default"].createElement(_InfoLabel["default"], {
          label: "Currently",
          tooltip: "You may open or close data collection."
        })
      }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_OpenClosedButtonGroup["default"], {
        wrapperClassName: "btn-group btn-group-sm",
        isOpen: open.value,
        setOpen: open.onChange
      }))), /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.FieldBlock, {
        field: opensOn,
        label: /*#__PURE__*/_react["default"].createElement(_InfoLabel["default"], {
          label: "Opens on",
          tooltip: "When would you like to allow responses?",
          optional: true
        })
      }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.DatePicker, {
        field: opensOn,
        placeholder: "Pick date & time",
        showTimeSelect: true
      }))), /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.FieldBlock, {
        field: closesOn,
        label: /*#__PURE__*/_react["default"].createElement(_InfoLabel["default"], {
          label: "Closes on",
          tooltip: "When would you like to stop accepting responses?",
          optional: true
        })
      }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.DatePicker, {
        field: closesOn,
        placeholder: "Pick date & time",
        showTimeSelect: true
      }))));
    }
  }]);
}(_react["default"].Component);
_defineProperty(TimeConfig, "propTypes", {
  fields: _propTypes["default"].object
});